import { TGetGroupedClientStacksParams } from 'types/services';
import { TGroupedStackInfo } from 'types/state';
import { m8API } from 'services/production/m8';
import { normalizeGroupedStackType } from 'services/production/utils/normalizeGroupedStackType';
import { normalizeM8GroupedClientStack } from 'services/production/utils/normalizeM8GroupedClientStack';

export const getGroupedClientStacks = async (
  params: TGetGroupedClientStacksParams
): Promise<TGroupedStackInfo[]> => {
  const { stackType } = params;

  const normalizedStackType = normalizeGroupedStackType(
    stackType
  ).toM8ClientStackType();

  const data = await m8API.admin.getGroupClientStacks(normalizedStackType);

  return data.map((item) =>
    normalizeM8GroupedClientStack(item).toGroupedStackInfo()
  );
};
